import { Navigate } from 'react-router-dom';

import { useAuthStore } from '@/auth/authStore';
import { currentInstitutionShortCode } from '@/lib/institutionHost';

// `/` decides which surface (portal vs learn vs login) the visitor lands on.
// With dual sessions a browser may hold both; prefer the parent surface, then
// kid, then the login screen.
export function RootPage() {
  const userToken = useAuthStore((s) => s.tokens.user);
  const kidToken = useAuthStore((s) => s.tokens.kid);
  const bootstrapped = useAuthStore((s) => s.bootstrapped);

  // A fresh navigation starts with empty in-memory tokens while useBootstrap
  // restores the HttpOnly sessions. Do not treat that state as signed out.
  if (!bootstrapped) {
    return (
      <div className="flex min-h-screen items-center justify-center text-slate-500">
        Loading session…
      </div>
    );
  }

  if (userToken) {
    return <Navigate to="/portal" replace />;
  }
  if (kidToken) {
    return <Navigate to="/learn" replace />;
  }

  // On an institution host the bare domain is the address a teacher writes on
  // the board — the whole point of the branded subdomain is that a child does
  // not type a school code or a deep link. Sending them to the parent login
  // would be a dead end twice over: it is Airbotix-branded, and under this
  // model the parents of institution students have no account at all.
  if (currentInstitutionShortCode()) {
    return <Navigate to="/learn/login" replace />;
  }

  return <Navigate to="/portal/login" replace />;
}
